<template>
  <div v-if="$route.name !='scorecard' && $route.name !='summary' && $route.name != 'display' && $route.name != 'lanes'">
  <nav class="navbar container" role="navigation" aria-label="main navigation" style="margin-left: 0px;">
    <div class="navbar-brand">
      <a class="navbar-item" href="/">
        <span class="axes2-title">
          <img class="axes2-title-logo" :src="`${publicPath}img/Axes2-text-logo-sm.png`"/>
        </span>
      </a>
      <a role="button" id="burger-button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbar">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
    <div id="navbar" class="navbar-menu">
      <div class="navbar-start">
        <router-link v-if="$auth.isAuthenticated"  to="/throw" class="navbar-item throw-link">Throw</router-link>
        <router-link to="/ranking2" class="navbar-item rankings-link">Rankings 2.0</router-link>
        <router-link to="/best" class="navbar-item best-link">Top Scores</router-link>
        <router-link v-if="$auth.isAuthenticated" to="/profile" class="navbar-item profile-link">Profile</router-link>
        <router-link v-if="$auth.isAuthenticated" to="/subscribe" class="navbar-item subscribe-link">Subscribe</router-link>
        <router-link to="/shop" class="navbar-item shop-link">Shop</router-link>
        <router-link to="/members" class="navbar-item members-link">Members</router-link>
        <router-link to="/display" class="navbar-item members-link">Display</router-link>
        <router-link v-if="$auth.isAuthenticated && this.isAdmin()" to="/admin" class="navbar-item admin-link">Admin</router-link>
        <router-link v-if="$auth.isAuthenticated && this.isAdmin()" to="/activity" class="navbar-item activity-link">Activity</router-link>
      </div>
      <div class="navbar-end">
          <div class="navbar-item">
            <div class="buttons">
              <!-- Check that the SDK client is not currently loading before accessing is methods -->
              <div v-if="!$auth.loading">
                  <!-- show login when not authenticated -->
                  <a v-if="!$auth.isAuthenticated" @click="login" class="button"><strong>Login</strong></a>
                  <!-- show logout when authenticated -->
                  <a v-if="$auth.isAuthenticated" @click="logout" class="button"><strong>Logout</strong></a>
              </div>
            </div>
          </div>
      </div>
    </div>
  </nav>
  <div v-if="isOffline" class="online-status">
    <p>It looks like you're offline?</p>
  </div>
</div>
</template>

<script>
    export default {
    name: 'Nav',
    data () {
      return {
          publicPath: process.env.BASE_URL
      }
    },
    computed: {
    },
    methods: {
        isAdmin() {
          return this.$parent.isAdmin();
        },
        login() {
            this.$auth.loginWithRedirect();
        },
        // Log the user out
        logout() {
            this.$auth.logout({
            returnTo: window.location.origin
            });
        },
        mountBurger() {
          //https://bulma.io/documentation/components/navbar/
          // Get all "navbar-burger" elements
          const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

          // Check if there are any navbar burgers
          if ($navbarBurgers.length > 0) {

            // Add a click event on each of them
            $navbarBurgers.forEach( el => {
              el.addEventListener('click', () => {

                // Get the target from the "data-target" attribute
                const target = el.dataset.target;
                const $target = document.getElementById(target);

                // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
                el.classList.toggle('is-active');
                $target.classList.toggle('is-active');

              });
            });
          }
        }
      },
      computed: {
        networkStatus () {
          return this.isOnline ? 'ONLINE' : 'OFFLINE'
        }
      },
      mounted(){
        this.mountBurger();
      }
    }
</script>

<style lang="scss" scoped>
  .online-status {
    font-family: Verdana;
    font-size: 1.25em;
    width: 100%;
    text-align: center;
    padding: 5px;
    background-color: #d88d00;
    color: #0c773c
  }
  nav {
    font-size: 1.6em;
    background-color: #383838;
    margin-bottom: 10px;
    a {
      font-weight: bold;
      color: black;
      &.router-link-exact-active {
        color: yellow;
      }
    }
    a:hover {
      color: yellow;
    }
  }
  .burger {
    color: yellow !important;
  }
  .axes2-title {
    /*
      padding-top: 10px;
      color: #0c773c
      */
      width: 200px;
  }
  .axes2-title-logo {
    max-height: 70px !important;
    padding-right: 20px;
    width: 200px;
    height: 70px;
  }
  .navbar-item {
    background-color: #383838 !important;
    font-size: 0.7em;
  }
  .router-link-exact-active, .router-link-exact-active:active {
    background-color: #383838;
  }
  .navbar-item:hover, .navbar-item:active {
    background-color: #383838;
  }
  .navbar-brand, .navbar-menu {
    background-color: #383838;
  }
  .home-link {
    color: gray;
  }
  .throw-link {
    color: green;
  }
  .practice-link,  .rankings-link, .best-link, .practice-link, .profile-link, .members-link, 
  .display-link, .shop-link, .activate-link, .subscribe-link {
    color: gray;
  }
  .admin-link, .activity-link {
    color: red;
  }
  .profile-link:hover, .members-link:hover, .practice-link:hover, .shop-link:hover, .rankings-link:hover, .best-link:hover, .home-link:hover, .activate-link:hover, .subscribe-link:hover, .admin-link:hover, .activity-link:hover {
      color: yellow !important;
  }
  .profile-link, .members-link, .practice-link, .shop-link, .rankings-link, .best-link, .home-link, .activate-link, .subscribe-link, .admin-link, .activity-link {
    font-size: 0.6em;
    padding-left: 6px;
    padding-right: 6px;
  }
</style>